import { WebsiteToggleOption } from "components/MobileNavigation/components/WebsiteToggleDropdown";

export const WEB_TOGGLE_OPTIONS: WebsiteToggleOption[] = [
    { name: 'Marketing', href: 'https://marketing.upgrade.com.do/' },
    { name: 'Software', href: 'https://software.upgrade.com.do/' },
    { name: 'Bundle', href: 'https://landing.upgrade.com.do/'  },
    { name: 'Learn More', href: 'https://upgrade.com.do/' },
  ];